import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_SettingBlock = _resolveComponent("SettingBlock")!
  const _component_ProductTable = _resolveComponent("ProductTable")!
  const _component_FormFooter = _resolveComponent("FormFooter")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    "tab-id": _ctx.selectedTabId,
    "onUpdate:tab-id": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    title: _ctx.pageTitle,
    "is-content-loading": _ctx.isContentLoading,
    tabs: _ctx.tabList
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_FormFooter, {
        "back-href": _ctx.backButtonUrl,
        "is-submitting": _ctx.isSubmitting,
        "is-creation": _ctx.isCreation,
        "can-create-another": _ctx.isCreation,
        onSubmit: _ctx.submitForm
      }, null, 8, ["back-href", "is-submitting", "is-creation", "can-create-another", "onSubmit"])
    ]),
    default: _withCtx(() => [
      (_ctx.isCreation)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            novalidate: "",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_FormField, {
              value: _ctx.values.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.name) = $event)),
              label: "Название",
              error: _ctx.errors.name,
              name: "name"
            }, null, 8, ["value", "error"])
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            novalidate: "",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_ctx.selectedTabId === 'common')
              ? (_openBlock(), _createBlock(_component_FormField, {
                  key: 0,
                  value: _ctx.values.name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.name) = $event)),
                  label: "Название",
                  error: _ctx.errors.name,
                  name: "name"
                }, null, 8, ["value", "error"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'properties')
              ? (_openBlock(), _createBlock(_component_SettingBlock, {
                  key: 1,
                  values: _ctx.values
                }, null, 8, ["values"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'products')
              ? (_openBlock(), _createBlock(_component_ProductTable, {
                  key: 2,
                  params: _ctx.values.params,
                  products: _ctx.values.products,
                  "product-search-list-option": _ctx.productSearchOptionList,
                  "handle-product-search-query-change": _ctx.handleProductSearchQueryChange,
                  "no-product-options-message": _ctx.noProductOptionsMessage,
                  "is-product-loading": _ctx.isProductLoading
                }, null, 8, ["params", "products", "product-search-list-option", "handle-product-search-query-change", "no-product-options-message", "is-product-loading"]))
              : _createCommentVNode("", true)
          ], 32))
    ]),
    _: 1
  }, 8, ["tab-id", "title", "is-content-loading", "tabs"]))
}